module.exports = __webpack_public_path__ + "static/media/07.d4f1bc0f.jpg";